let initialState = {};

let saitbarReducer = (state = initialState, action) => {
return state;
}

export default saitbarReducer;